import React from "react";

const Progress = ({ strokeWidth, label , percentage }) => {
    const radius = (40 - strokeWidth / 2);
    const pathDescription = `
      M 50,50 m 0,-${radius}
      a ${radius},${radius} 0 1 1 0,${2 * radius}
      a ${radius},${radius} 0 1 1 0,-${2 * radius}
    `;

    const diameter = Math.PI * 2 * radius;
    const progressStyle = {
        stroke: '#007dbc',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeDasharray: `${diameter}px ${diameter}px`,
        strokeDashoffset: `${((100 - percentage) / 100 * diameter)}px`,
    };

    return (
      <div
        className="progress-outer"
        style={{ display: "flex", alignItems: "center" }}
      >
        <span
          className="text"
          style={{
            fontSize: "0.7vw",
            fontWeight: 500
          }}
        >
          {`${label}`}
        </span>
        <svg
          className={"CircularProgressbar"}
          viewBox="0 0 100 100"
          width={55}
          height={55}
        >
          <path
            className="CircularProgressbar-trail"
            d={pathDescription}
            strokeWidth={strokeWidth}
            fillOpacity={0}
            style={{
              stroke: "#d6d6d6"
            }}
          />
          <path
            className="CircularProgressbar-path"
            d={pathDescription}
            strokeWidth={strokeWidth}
            fillOpacity={0}
            style={progressStyle}
          />

          <text
            className="CircularProgressbar-text"
            x="55%"
            y="35%"
            dy="1.2rem"
            textAnchor="middle"
            style={{
              fill: "#44acd1",
              dominantBaseline: "middle",
              fontSize: "24px",
              fontWeight: 700
            }}
          >
            {`${percentage}%`}
          </text>
        </svg>
      </div>
    );
};


export default Progress;